import * as actionTypes from './actionTypes';
import axios from '../../axios-orders';

export const purchasingInit = () => {
	return {
		type: actionTypes.PURCHASING_INIT,
	};
};

export const purchasingStarted = () => {
	return {
		type: actionTypes.PURCHASING_STARTED,
	};
};

export const purchaseBurgerSuccess = (orderData) => {
	return {
		type: actionTypes.PURCHASE_BURGER_SUCCESS,
		orderData,
	};
};

export const purchaseBurgerFail = (error) => {
	return {
		type: actionTypes.PURCHASE_BURGER_ERROR,
		error: error,
	};
};

export const purchaseBurger = (stripePromise, order, token) => {
	return (dispatch) => {
		dispatch(purchasingStarted());

		let stripe, session, result;
		stripePromise.then((str) => {
			stripe = str;
			return axios
				.post('orders', order, {
					headers: {
						Authorization: 'Bearer ' + token,
					},
				})
				.then((res) => {
					session = res.data;
					return stripe.redirectToCheckout({
						sessionId: session.id,
					});
				})
				.then((res) => {
					result = res;
					console.log(result);
					if (result.error) {
						dispatch(purchaseBurgerFail({ message: 'Payment Failed' }));
					} else {
						dispatch(purchaseBurgerSuccess({ message: 'Payment Success' }));
					}
				})
				.catch((e) => {
					console.log(e);
					dispatch(purchaseBurgerFail({ message: 'Payment Failed' }));
				});
		});
	};
};

export const fetchOrdersSuccess = (orders) => {
	return {
		type: actionTypes.FETCH_ORDERS_SUCCESS,
		orders: orders,
	};
};
export const fetchOrdersError = (error) => {
	return {
		type: actionTypes.FETCH_ORDERS_ERROR,
		error: error,
	};
};

export const fetchOrdersStart = () => {
	return {
		type: actionTypes.FETCH_ORDERS_START,
	};
};

export const fetchOrders = (token) => {
	return (dispatch) => {
		dispatch(fetchOrdersStart());
		axios
			.get('orders', {
				headers: {
					Authorization: 'Bearer ' + token,
				},
			})
			.then((res) => {
				const fetchedOrders = res.data.orders;
				dispatch(fetchOrdersSuccess(fetchedOrders));
			})
			.catch((e) => {
				dispatch(fetchOrdersError(e.response.data));
			});
	};
};
